<script setup lang="ts">
defineOptions({
  name: 'CyclabilityMapSettings',
})

const props = withDefaults(defineProps<{
  hasNetworkMetric?: boolean
}>(), {
  hasNetworkMetric: true,
})

const { t } = useI18n()
const cityStore = useCityStore()
const { slug, isLoading } = storeToRefs(cityStore)
const { translateFromData } = useLabelTranslation()

const {
  availableGeometries,
  availableAreasMetrics,
  areaActiveData,
  geometryType,
  areasMetric,
  availableNetworks,
  availableNetworkMetrics,
  networkMetric,
  networkType,
} = useCyclability(slug)

onMounted(() => {
  globalEmitter.on('filters:reset', () => {
    geometryType.value = availableGeometries.value?.[0].name
    networkType.value = availableNetworks.value?.[0].name
  })

  if (!props.hasNetworkMetric) {
    networkMetric.value = null
  }
})

onBeforeUnmount(() => {
  globalEmitter.off('filters:reset')
})
</script>

<template>
  <DSelectPicker
    v-model="geometryType"
    icon="hexagones"
    :options="[
      {
        label: t('None'),
        value: null,
      },
      // TOSEE: Hide auto value for now
      // ...(availableGeometries.length > 1 ? [{
      //   label: t('Auto (zoom level)'),
      //   value: 'auto',
      //   default: true,
      // }] : []),
      ...availableGeometries.map(({ name, label }) => ({ value: name, label })).sort((a, b) => a.label.localeCompare(b.label)),
    ]"
    :label="t('cyclability.filters.area_level_of_resolution')"
    :is-loading="isLoading"
    :default-text="`${translateFromData('geometry', areaActiveData?.name || geometryType as string)} (auto)`"
  />

  <DSelectPicker
    v-if="geometryType && availableAreasMetrics"
    v-model="areasMetric"
    icon="hexagones"
    :options="availableAreasMetrics.map(({ name, label }) => ({ value: name, label }))"
    :label="t('Area metric')"
    :is-loading="isLoading"
  />

  <DSelectPicker
    v-model="networkType"
    icon="hexagones"
    :label="t('cyclability.filters.bike_network_selection')"
    :is-loading="isLoading"
    :options="[
      {
        label: t('None'),
        value: null,
      },
      ...availableNetworks.map(({ name, label }) => ({ value: name, label })),
    ]"
  />

  <DSelectPicker
    v-if="hasNetworkMetric && networkType && availableNetworkMetrics"
    v-model="networkMetric"
    icon="hexagones"
    :options="[
      {
        label: t('Road type'),
        value: null,
      },
      ...availableNetworkMetrics.map(({ name, label }) => ({ value: name, label })),
    ]"
    :label="t('cyclability.filters.bike_network_metric')"
    :is-loading="isLoading"
  />
</template>
